export const SELLER_BRAND_TYPE = 'seller'
export const VENDOR_BRAND_TYPE = 'vendor'
